import { createClient } from '@supabase/supabase-js';

const SUPABASE_URL = process.env.REACT_APP_SUPABASE_URL;
const SUPABASE_ANON_KEY = process.env.REACT_APP_SUPABASE_ANON_KEY;

if (!SUPABASE_URL || !SUPABASE_ANON_KEY) {
  if (process.env.NODE_ENV === 'development') {
    console.error('❌ ERREUR: Configuration Supabase incomplète!');
  }
}

export const supabase = createClient(SUPABASE_URL, SUPABASE_ANON_KEY);

// Test de connexion au démarrage (dev only)
export const testSupabaseConnection = async () => {
  if (process.env.NODE_ENV !== 'development') {
    return { success: true };
  }
  
  try {
    // Test 1: Vérifier que Supabase répond
    const { data: testData, error: testError } = await supabase
      .from('subscribers')
      .select('id')
      .limit(1);
    
    if (testError) {
      return { success: false, error: testError };
    }
    
    return { success: true, data: testData };
  } catch (error) {
    return { success: false, error };
  }
};

export default supabase;
